import { drawerAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(drawerAnatomy.keys);

const baseStyle = definePartsStyle({
  // define the part you're going to style
  dialogContainer: {},
  dialog: {
    bg: "blueGray.100",
    color: "white",
  },
});
export const drawerStyle = defineMultiStyleConfig({ baseStyle });
